import {css} from '@emotion/react'
import CompareProduct from './MenuButtonCompareProduct.jsx'
import Difference from './Difference.jsx'
import MapInfo from './MapInfo.jsx'
import ToggleCompareRef from './ToggleCompareRef.jsx'

const cssToolBar = css({
    display: 'grid',
    gridTemplateColumns: '1fr auto 1fr',
    alignItems: 'center',
})

const cssCenter = css({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
})

const cssSubMenu = css({
    display: 'flex',
    gap: 12,
})

export default function ToolBar({diffMap, ...props}) {
    return (
        <div
            css={cssToolBar}
            {...props}
        >
            <MapInfo map={diffMap.leftMap} />

            <div css={cssCenter}>
                <Difference />

                <div css={cssSubMenu}>
                    <CompareProduct />
                    <ToggleCompareRef />
                </div>
            </div>

            <MapInfo map={diffMap.rightMap} />
        </div>
    )
}
